import * as React from 'react'
import './styles.css'
// libs
import { motion } from 'motion/react'
// components
import Glow from '../../../../glows'
import LearnMoreButton from '../LearnMoreButton'
import AnimatedContainer from '../../../../ui/AnimatedContainer/animatedContainer'
// views
import {
  titleAnimation,
  subtitleAnimation,
} from '../../../../../constants/animation'
// assets
import Poster from '../../../../../assets/imgs/recruting/poster.png'
import { ReactComponent as CheckIcon } from '../../../../../assets/imgs/recruting/feather-check.svg'

const POD_RECRUITING_DATA = [
  'Find the right candidate in seconds',
  'AI screening to dramatically boost efficiency',
  'Effortlessly manage any volume of incoming resumes',
]

const HOW_IT_WORKS_VIDEO_LINK =
  'https://atlasjobs.blob.core.windows.net/samples-workitems/Chris-video_1.mp4'

const PodRecruitingSection = () => {
  return (
    <section className='recruiting-content'>
      <div className='box'>
        <Glow position='right' />

        <AnimatedContainer className='recruiting-grid-container pod-recruiting-grid-ext'>
          <div className='recruiting-left-content'>
            <motion.p
              className='recruiting-main-title'
              variants={titleAnimation}
            >
              Pod Recruiting
            </motion.p>
            <motion.p
              className='recruiting-sub-content-container'
              variants={subtitleAnimation}
            >
              {POD_RECRUITING_DATA.map((text, index) => (
                <div key={index} className='recruiting-sub-content'>
                  <div className='recruiting-sub-content-icon'>
                    <CheckIcon />
                  </div>
                  <div>{text}</div>
                </div>
              ))}
            </motion.p>
            <div className='recruiting-button-container'>
              <LearnMoreButton />
            </div>
          </div>
          <div className='video-section'>
            <h3 className='video-title'>See How it Works</h3>

            <div className='video-container'>
              <video
                controls
                playsInline
                poster={Poster}
                preload='auto'
                className='how-media'
                style={{ display: 'block' }}
                disablePictureInPicture
                controlsList='nodownload noplaybackrate'
              >
                <source src={HOW_IT_WORKS_VIDEO_LINK} type='video/mp4' />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </AnimatedContainer>
      </div>
    </section>
  )
}

export default PodRecruitingSection
